import Vue from 'vue';
import i18n from '@/lib/i18n';
import { isEqual } from 'lodash';

const state = {
  formValues: {},
  orgFormValues: {},
  fieldErrors: {},
  validationRules: {}
};

const getters = {
  hasErrors(state) {
    return Object.values(state.fieldErrors).some(e => e !== null);
  },
  isFormDataChanged(state) {
    if (Object.keys(state.orgFormValues).length === 0) return false;

    return !isEqual(state.formValues, state.orgFormValues);
  }
};

const validators = {
  required: v => (v != null && v !== '' ? true : i18n.t('validations.required'))
};

const mutations = {
  SET_FORM_VALUES(state, data) {
    state.formValues = { ...data };
  },
  SET_ORG_FORM_VALUES(state, data) {
    state.orgFormValues = { ...data };
  },
  SET_FIELD_VALUE(state, { key, value }) {
    Vue.set(state.formValues, key, value);
  },
  SET_VALIDATION_RULES(state, rules) {
    state.validationRules = rules;
  },
  RESET_FIELD_ERRORS(state) {
    state.fieldErrors = {};
  },
  SET_FIELD_ERROR(state, { key, error }) {
    Vue.set(state.fieldErrors, key, error);
  }
};

const actions = {
  setFormValues({ commit }, data) {
    commit('SET_FORM_VALUES', data);
  },
  initFormValues({ commit }, data) {
    commit('SET_FORM_VALUES', data);
    commit('SET_ORG_FORM_VALUES', data);
  },
  setValidationRules({ commit }, rules) {
    commit('SET_VALIDATION_RULES', rules);
    commit('RESET_FIELD_ERRORS');
  },
  setFieldValue({ state, commit, dispatch }, { key, value, validate = false }) {
    commit('SET_FIELD_VALUE', { key, value });

    // 변경 전 오류가 있었으면 즉시 검사. 그 외의 경우 blur 시 검사
    if (state.fieldErrors[key] || validate) dispatch('validateField', key);
  },
  validateField({ state, commit }, key) {
    const rules = state.validationRules[key];
    if (!rules) return;

    const value = state.formValues[key];
    let error = null;
    for (const key in rules) {
      const rule = rules[key];
      const validatorFn =
        rule === true
          ? validators[key]
          : typeof rule === 'function'
          ? rule
          : null;
      if (!validatorFn) continue;

      const result = validatorFn(value);
      if (result !== true) {
        error = result;
        break;
      }
    }

    commit('SET_FIELD_ERROR', { key, error });
  },
  async validateAll({ state, dispatch, getters }) {
    const keys = Object.keys(state.validationRules);
    await Promise.all(keys.map(key => dispatch('validateField', key)));

    return !getters.hasErrors;
  }
};

export default { namespaced: true, state, getters, mutations, actions };
